import { useResendInvitationMutation } from '@/api/api.slice.tsx';
import { openDialogCancelInvite } from '@/features/accounts/accounts.slice.ts';
import { AccountType } from '@/features/accounts/types.ts';
import { useConnectToUserAccount } from '@/features/accounts/useConnectToUserAccount.ts';
import i18n from '@/i18n/i18n.ts';
import { Button } from '@arsnovasystems/ars-front-lib';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

/**
 * Component to display the actions cell when in grid mode
 *
 * @param props      Props
 * @param props.data The data of the row
 *
 * @returns          The ActionsCell component
 */
export const ActionsCell = ({ data }: { data: AccountType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [resendInvitation, { isLoading: resendInvitationIsLoading }] =
    useResendInvitationMutation();

  const onClickConnect = useConnectToUserAccount({
    userPublicId: data.id,
  });

  return (
    <Stack
      direction={'row'}
      sx={{
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 1,
        height: '100%',
      }}
    >
      {!data.isInvitation && (
        <Button
          size='small'
          variant='contained'
          onClick={onClickConnect}
        >
          {i18n.t('ik.connect')}
        </Button>
      )}
      {data.isInvitation && (
        <Button
          loading={resendInvitationIsLoading}
          onClick={() => {
            void resendInvitation({
              email: data.email,
              companyName: data.companyName,
              contactName: data.contactName,
            });
          }}
        >
          {i18n.t('ik.resend.invitation')}
        </Button>
      )}
      {data.isInvitation && (
        <Button
          color={'secondary'}
          variant={'outlined'}
          onClick={() => {
            dispatch(openDialogCancelInvite(data));
          }}
        >
          {t('ik.customerAccounts.cardMenu.cancelInvitation.label')}
        </Button>
      )}
    </Stack>
  );
};
